export const DEFAULT_PAGE_SIZE = 1000

function DEFAULT_PROPS() {
  return {
    pageSize: DEFAULT_PAGE_SIZE,
    pages: [],
    idMap: {},
    lastPageIndex: null,
    lastRectIndex: null,
    leftBorder: null,
    rightBorder: null
  }
}

const PUBLIC = {
  add(id, rect) {
    if (rect.left === rect.right || rect.top === rect.bottom) {
      return this.PUBLIC
    }
    const { pages, idMap, pageSize, leftBorder, rightBorder } = this.props
    const topPageIndex = Math.floor(rect.top / pageSize)
    const bottomPageIndex = Math.floor(rect.bottom / pageSize)
    for (let pageIndex = topPageIndex; pageIndex <= bottomPageIndex; pageIndex++) {
      if (null == pages[pageIndex]) {
        pages[pageIndex] = [
          {
            id,
            top: rect.top,
            bottom: rect.bottom
          }
        ]
      } else {
        pages[pageIndex].push({
          id,
          top: rect.top,
          bottom: rect.bottom
        })
      }
    }
    idMap[id] = { rect, topPageIndex, bottomPageIndex }
    this.props.leftBorder = null == leftBorder ? rect.left : Math.min(leftBorder, rect.left)
    this.props.rightBorder = null == rightBorder ? rect.right : Math.max(rightBorder, rect.right)
    return this.PUBLIC
  },
  bake({ topPageIndex = 0, bottomPageIndex = this.props.pages.length - 1 } = {}) {
    const { pages } = this.props
    for (let i = topPageIndex; i <= bottomPageIndex; i++) {
      if (null != pages[i]) {
        pages[i].sort(function (a, b) {
          return a.top - b.top
        })
      }
    }
    return this.PUBLIC
  },
  isEmpty() {
    return 0 == this.props.pages.length
  },
  clear() {
    this.props.pages = []
    this.props.idMap = {}
    this.props.lastPageIndex = null
    this.props.lastRectIndex = null
    this.props.leftBorder = null
    this.props.rightBorder = null
    return this.PUBLIC
  },
  update(id, rect) {
    const { pages, idMap } = this.props
    const prevRecord = idMap[id]
    // remove old record
    if (null != prevRecord) {
      const { topPageIndex, bottomPageIndex, rect: prevRect } = prevRecord
      if (
        null != rect &&
        rect.left === prevRect.left &&
        rect.right === prevRect.right &&
        rect.top === prevRect.top &&
        rect.bottom === prevRect.bottom
      ) {
        // no update needed
        return this.PUBLIC
      }
      for (let i = topPageIndex; i <= bottomPageIndex; i++) {
        if (null == pages[i]) {
          continue
        }
        pages[i] = pages[i].filter(record => record.id !== id)
      }
    }
    if (null != rect) {
      // add new record
      this.PUBLIC.add(id, rect)
      // bake affected range
      const { topPageIndex, bottomPageIndex } = idMap[id]
      this.PUBLIC.bake({ topPageIndex, bottomPageIndex })
    }
    // return api
    return this.PUBLIC
  },
  test(x, y) {
    const lastPageIndex = this.props.lastPageIndex
    const testPageIndex = Math.floor(y / this.props.pageSize)
    this.props.lastPageIndex = testPageIndex
    if (
      (null != this.props.leftBorder && x < this.props.leftBorder) ||
      (null != this.props.rightBorder && x > this.props.rightBorder)
    ) {
      // left horizontal borders
      this.props.lastRectIndex = null
      return void 0
    }
    const testPage = this.props.pages[testPageIndex]
    if (null != testPage) {
      if (lastPageIndex == testPageIndex) {
        // same page
        if (null != this.props.lastRectIndex) {
          const lastRect = testPage[this.props.lastRectIndex]
          if (y >= lastRect.top && y <= lastRect.bottom) {
            // we still inside last rect
            return lastRect.id
          } else if (this.props.lastRectIndex > 0 && y < lastRect.top) {
            // scan up
            for (let i = this.props.lastRectIndex - 1; i >= 0; i--) {
              const possibleRect = testPage[i]
              if (y >= possibleRect.top && y <= possibleRect.bottom) {
                this.props.lastRectIndex = i
                return possibleRect.id
              } else if (y > possibleRect.bottom) {
                break
              }
            }
          } else if (this.props.lastRectIndex < testPage.length - 1 && y > lastRect.bottom) {
            // scan down
            for (let i = this.props.lastRectIndex + 1; i < testPage.length; i++) {
              const possibleRect = testPage[i]
              if (y >= possibleRect.top && y <= possibleRect.bottom) {
                this.props.lastRectIndex = i
                return possibleRect.id
              } else if (y < possibleRect.top) {
                break
              }
            }
          }
        } else {
          // full page scan if no lastRectIndex
          for (const [i, possibleRect] of testPage.entries()) {
            if (y >= possibleRect.top && y <= possibleRect.bottom) {
              this.props.lastRectIndex = i
              return possibleRect.id
            }
          }
        }
      } else {
        // other page
        if (null != lastPageIndex && lastPageIndex > testPageIndex) {
          // scan from bottom
          for (let i = testPage.length - 1; i >= 0; i--) {
            const possibleRect = testPage[i]
            if (y >= possibleRect.top && y <= possibleRect.bottom) {
              this.props.lastRectIndex = i
              return possibleRect.id
            } else if (y > possibleRect.bottom) {
              break
            }
          }
        } else {
          // scan from top
          for (const [i, possibleRect] of testPage.entries()) {
            if (y >= possibleRect.top && y <= possibleRect.bottom) {
              this.props.lastRectIndex = i
              return possibleRect.id
            } else if (y < possibleRect.top) {
              break
            }
          }
        }
      }
    }
    // nothing found
    this.props.lastRectIndex = null
    return null
  }
}

export default function RectVHitTest(props = {}) {
  const RectVHitTest = {
    props: Object.assign({}, DEFAULT_PROPS(), props)
  }
  RectVHitTest.PUBLIC = {
    add: PUBLIC.add.bind(RectVHitTest),
    bake: PUBLIC.bake.bind(RectVHitTest),
    isEmpty: PUBLIC.isEmpty.bind(RectVHitTest),
    clear: PUBLIC.clear.bind(RectVHitTest),
    update: PUBLIC.update.bind(RectVHitTest),
    test: PUBLIC.test.bind(RectVHitTest)
  }
  return RectVHitTest.PUBLIC
}
